<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSpotlight_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <g fill="currentColor" clip-path="url(#IconSpotlight_16__a)">
        <path
            d="M0 1.455v2.181h1.455V1.455h2.181V0H1.455A1.4 1.4 0 0 0 .427.427 1.4 1.4 0 0 0 0 1.455M1.455 16h2.181v-1.454H1.455v-2.182H0v2.182q0 .6.427 1.027A1.4 1.4 0 0 0 1.455 16M12.364 14.546V16h2.182a1.4 1.4 0 0 0 1.027-.427A1.4 1.4 0 0 0 16 14.546v-2.182h-1.454v2.182zM14.546 1.455v2.181H16V1.455a1.4 1.4 0 0 0-.427-1.028A1.4 1.4 0 0 0 14.546 0h-2.182v1.455zM8.276 8.308a2.33 2.33 0 0 0 2.32-2.336 2.33 2.33 0 0 0-2.32-2.336 2.33 2.33 0 0 0-2.32 2.336 2.33 2.33 0 0 0 2.32 2.336M11.791 10.427c-.604-.65-1.742-1.133-3.791-1.133-2.066 0-3.206.492-3.806 1.15l-.016.017c-.162.178-.424.466-.534 1.173-.06.382.24.73.624.73h7.464a.634.634 0 0 0 .624-.73c-.11-.717-.38-1.007-.554-1.195z"
        />
    </g>
    <defs>
        <clipPath id="IconSpotlight_16__a">
            <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
    </defs>
</svg>
